










import { Component, Prop } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { mixins } from "vue-class-component";

@Component
export default class AdminInvoices extends mixins(RequestPromises) {
  @Prop({ default: [] })
  public routes!: any[];
}
